import Switch from "../../../general/Switch.tsx";
import {InfoTooltip} from "../../../general/InfoTooltip.tsx";

interface PredictedAccountsToggleProps {
    checked: boolean;
    onChange: (value: boolean) => void;
}

export function PredictedAccountsToggle({checked, onChange}: PredictedAccountsToggleProps) {
    return (
        <div className="flex h-9 items-center gap-2">
            <label className="flex cursor-pointer items-center gap-2.5">
                <Switch checked={checked} onChange={onChange} />
                <span className="text-[13px] font-semibold text-gray-700">
                    Voorspelde grootboekrekeningen
                </span>
            </label>
            <InfoTooltip text="Toont ook grootboekrekeningen met voorspelde bedragen voor de gekozen periode." />
        </div>
    );
}
